// extracted by mini-css-extract-plugin
module.exports = {"switch":"index_switch_2htGI","slider":"index_slider_23IrV","round":"index_round_M1vEj"};